<template>

    <div class="border-b border-theme-level2 bg-theme-level4 flex flex-col">

        <!--<div id="hero-content-container" class="hero-section bg-theme-level4 cursor-pointer pr-6" :style="heroContentStyling">-->
        <div id="hero-content-container" class="hero-section bg-theme-level4 cursor-pointer">

            <!--<div class="flex-1"></div>-->

            <div class="mainSection flex-grow flex-no-shrink" style="max-height: 395px;">

                <div class="w-full flex">

                    <hero-video-player :currentlocale="currentlocale"
                                       :herocontent="herocontent" style="max-height: 395px;" ref="mobilePlayer"></hero-video-player>

                </div>

                <div class="flex flex-col py-4 px-4" @click="showPlayerForHero">

                    <p class="text-theme-title text-lg leading-tight font-bold mb-4">{{ this.heroContent.title }}</p>

                    <p class="text-xs text-theme-main leading-normal">{{ heroTextContent }}</p>

                    <span class="text-xs text-theme-discrete flex flex-row items-center mb-2 mt-4">
                        <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                        <span class="flex-1">{{ translate('published-on') }} <span v-text="date"></span>, {{ translate('at') }} <span v-text="time"></span></span>
                    </span>

                </div>

            </div>



        </div>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [
            'currentlocale',
            'herocontent',
            'extra_links',
            'complementary_content',
            'bkg_urls'
        ],

        data() {

            return {

                heroContent: JSON.parse(this.herocontent),

                shareableLinkPanelVisible: false,
                shareableLinkWasCopied: false,
                shareableLinkHadError: false,
                copy_label: this.translate('copy'),

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_LegacyThumbnails_DNS_Name: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME,
                ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY

            }

        },


        computed: {

            date() {
                return this.heroContent.publish_date.split(' ')[0]
            },

            time() {
                return this.heroContent.publish_date.split(' ')[1]
            },

            cloudSource() {

                if(this.heroContent.legacy) {
                    return this.ENV_CloudFront_LegacyThumbnails_DNS_Name;
                } else {
                    return this.ENV_CloudFront_DNS_Name;
                }

            },

            thumbnailURL() {

                if(this.heroContent.legacy) {
                    return this.cloudSource + this.heroContent.thumbnail_url;
                } else {
                    return this.cloudSource + this.heroContent.thumbnail_url;
                }

            },

            shareableLinkCode() {

                return 'https://' + window.location.hostname + '/' + this.currentlocale + '/content/' + this.heroContent.id;

            },

            downloadable() {

                return this.heroContent.restrictions === 'Abierto' || this.heroContent.restrictions === 'Open';

            },

            heroTextContent() {

                if(this.heroContent.hero_text) {
                    return this.heroContent.hero_text;
                } else {
                    return this.heroContent.abstract.substring(0, 100) + '...';
                }

            },

            heroContentStyling() {

                let background = '';
                let suffix = this.$root.shared.theme === 'theme-dark' ? '_dark.jpg' : '_light.jpg';

                if(this.heroContent.hero_background===3) {
                    if(this.$root.shared.theme==='theme-light') {
                        background = 'url(' + this.ENV_CloudFront_DNS_Name + this.heroContent.filename + '/' + this.ENV_Thumbnail_Key + this.heroContent.hero_background_image + '.jpg' + ')';
                    } else {
                        background = 'url(' + this.ENV_CloudFront_DNS_Name + this.heroContent.filename + '/' + this.ENV_Thumbnail_Key + this.heroContent.hero_background_image_dark + '.jpg' + ')';
                    }
                } else {
                    background = 'url(' + JSON.parse(this.bkg_urls)[this.heroContent.hero_background] + suffix + ')'
                }

                /*console.log('Returning as Background URL: ' + background);*/

                return {
                    'background-size': 'contain',
                    'background-image': background,
                    'background-repeat': 'no-repeat',
                    'max-height': '395px',
                    'max-width': '1400px'
                }

            },

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            getShareableLink() {
                this.shareableLinkPanelVisible=true;
            },

            setCopyLabelOk() {
                this.copy_label = this.translate('copied');
            },

            setCopyLabelError() {
                this.copy_label = 'Error!';
            },

            copyLinkToClipboard() {

                this.$copyText(this.shareableLinkCode).then((e) => {
                    this.setCopyLabelOk();
                    this.shareableLinkWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.shareableLinkHadError=true;
                    console.log(e)
                })
            },

            downloadContent() {
                if(this.heroContent.legacy) {
                    window.location=process.env.MIX_CLOUDFRONT_LEGACY_DNSNAME + this.heroContent.filename;
                } else {
                    window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.heroContent.filename + '/' + this.heroContent.filename + '.mp4';
                }
            },

            showPlayerForHero() {

                // console.log(JSON.stringify(this.heroContent));

                this.$refs['mobilePlayer'].$refs['videoPlayer'].player.pause();
                Event.fire('showPlayer', { language: this.currentlocale, data: this.heroContent });

            },

            showExtraLinkPlayer(content) {

                // console.log(JSON.stringify(JSON.parse(this.extra_links)[content]));
                Event.fire('showPlayer', { language: this.currentlocale, data: JSON.parse(this.extra_links)[content] });

            },

            showComplementaryPlayer(content) {

                Event.fire('showPlayer', { language: this.currentlocale, data: JSON.parse(this.complementary_content)[content] })

            }

        },

    }

</script>

<style>

    .hero-section {

        display: flex;
        flex-flow: row;

        /*min-height: 250px;
        max-height: 325px;*/

        /*display: grid;
        grid-template-columns: repeat(11, minmax(90px, 1fr));
        grid-template-rows: minmax(250px, min-content);
        grid-template-areas:
            "main main main main main data data data data more more";*/
    }

    .hero-section-grow {
        flex: 1 1 auto;
    }

    .mainSection {
        /*grid-area: main;*/
    }

    .dataSection {
        /*grid-area: data;*/
    }

    .moreSection {
        /*grid-area: more;*/
    }

    .inline-svg-icon {
        fill: var(--txt-discrete);
    }

    .inline-svg-icon:hover {
        fill: var(--txt-main);
    }

    .text-concat {
        max-width: 400px;
        overflow: hidden;
        /*padding: 20px;*/
        /*background: #eaeaea;*/
        /*margin: 50px auto;*/
        /*position: relative;
        display: inline-block;
        word-wrap: break-word;
        overflow: hidden;
        max-height: 3.2em;
        line-height: 1.6em;*/
    }

    .text .ellipsis ::after {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        /*content: "...";
        position: absolute;
        right: -12px;
        bottom: 4px;*/
    }


    /*.this-player-fit {
        position: relative !important;
        width: 100% !important;
        max-height: 480px;
        !*height: auto !important;*!
    }*/

</style>
